import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  ref: "grid-top",
  class: "scroll-mt-10"
}
const _hoisted_3 = {
  key: 0,
  class: "flex-1"
}
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 scroll-pt-4" }
const _hoisted_5 = {
  key: 1,
  class: "text-center py-12"
}

import { useTemplateRef } from 'vue';
import { useProductsStore } from "../stores/products";
import LoadingIndicator from "@js/components/LoadingIndicator.vue";
import ListPagination from "@js/components/ListPagination.vue";
import ProductItem from "./ProductItem.vue";
import ProductListPlaceholder from "./ProductListPlaceholder.vue";
import { useFiltersStore } from '../stores/filters';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductList',
  setup(__props) {

const gridTop = useTemplateRef('grid-top')
const store = useProductsStore();
const filtersStore = useFiltersStore();

function onPageChange(page: number) {
  store.currentPage = page;
  if (gridTop.value) {
    gridTop.value.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest'
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, null, 512),
    (_unref(store).products && _unref(store).products.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).products, (product) => {
              return (_openBlock(), _createElementBlock("div", {
                key: product.id
              }, [
                _createVNode(ProductItem, { product: product }, null, 8, ["product"])
              ]))
            }), 128))
          ]),
          _createVNode(ListPagination, {
            "total-pages": _unref(store).totalPages,
            "current-page": _unref(store).currentPage,
            onChange: onPageChange
          }, null, 8, ["total-pages", "current-page"])
        ]))
      : _createCommentVNode("", true),
    (!_unref(store).isLoading && _unref(store).products && !_unref(store).products.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("div", null, " Ingen resultater for dette søket ", -1)),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(filtersStore).resetAllFilters && _unref(filtersStore).resetAllFilters(...args)), ["prevent"])),
              class: "text-teal underline"
            }, "Tilbakestill alle filter")
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(store).isLoading && !_unref(store).products.length)
      ? (_openBlock(), _createBlock(ProductListPlaceholder, { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(LoadingIndicator, {
      "is-loading": _unref(store).products.length > 0 && _unref(store).isLoading
    }, null, 8, ["is-loading"])
  ]))
}
}

})